// extracted by mini-css-extract-plugin
module.exports = {"outer":"BIlJL","radioSection":"_1fL2c","textAera":"_2e4-J","buttonWrapper":"_2L_Or","viewButton":"_3zy2Q","bookButton":"_18dgn"};